import type { InstrumentId } from "./score";

/** Four original SVG silhouettes at the same 88px scale as the series icons. */
export const InstrumentIcon:React.FC<{instrument:InstrumentId}>=({instrument})=>(
  <g fill="none" stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round">
    {instrument==="brass" && <>
      <path d="M-30 -8 H-21 L-15 -14 H12 L27 -23 V19 L12 10 H-15 L-21 4 H-30 Z" fill="currentColor" fillOpacity=".15"/>
      <path d="M-16 -14 V10 M-11 10 V23 H0 V10 M-6 -13 V-23 M1 -13 V-23 M8 -13 V-23 M-8 -24 H-4 M-1 -24 H3 M6 -24 H10"/>
      <path d="M-33 -8 V4 M27 -23 Q37 -8 27 19"/>
    </>}
    {instrument==="strings" && <>
      <path d="M-2 -32 L-2 -9 C-24 -16 -30 5 -17 14 C-28 29 -3 38 12 23 C21 12 16 -5 4 -9 V-32" fill="currentColor" fillOpacity=".13"/>
      <path d="M-2 -32 H4 M-17 2 H13 M-17 17 H13 M-4 -33 V28 M3 -33 V28 M-25 31 L25 -29"/>
      <circle cx="-12" cy="-6" r="2" fill="currentColor"/><circle cx="8" cy="22" r="2" fill="currentColor"/>
    </>}
    {instrument==="bass" && <g transform="rotate(28)">
      <path d="M-7 -8 C-28 -14 -26 4 -19 9 C-32 30 -5 37 9 22 C18 12 12 3 7 0 C16 -12 3 -20 0 -8" fill="currentColor" fillOpacity=".18"/>
      <path d="M-3 15 V-32 H4 V15 M-10 18 H8 M-4 -33 L-4 -39 H6 V-33 M-8 -35 H-4 M6 -38 H10"/>
    </g>}
    {instrument==="percussion" && <>
      <ellipse cy="-4" rx="24" ry="9" fill="currentColor" fillOpacity=".18"/>
      <path d="M-24 -4 V19 C-24 31 24 31 24 19 V-4 M-23 2 L-12 23 L0 5 L12 23 L23 2 M-23 -28 L6 -10 M23 -28 L-6 -10"/>
    </>}
  </g>
);
